import axios from 'axios'

export default {
  state: {},
  mutations: {},
  actions: {
    CHECK_YOUTUBE_URL: ({ commit, rootGetters }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(rootGetters.urlLanguagePrefix + '/site/youtube-video-info/?url=' + url)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
